module.exports = __webpack_public_path__ + "img/6pica.c99b0f04.png";